export const scorecardData = `
iBattingTeamId
    aBatters {
      oCommentary {
    sComSummary
    sCommentary
    sOver
    sBall
    sText
  }
      eDismissal
      nBallFaced
      nFours
      nRuns
      nSixes
      oBatter {
        isWk
        isCaptain
        sShortName
        sFullName
        eTagStatus
        oSeo {
          sSlug
        }
        oImg {
          sUrl
        }
      }
      sHowOut
      sStrikeRate
      iBatterId
      nDots
      nFives
      nSingles
      nThree
      nDoubles
    }
    aBowlers {
      nMaidens
      oBowler {
        isWk
        isCaptain
        sShortName
        sFullName
        eTagStatus
        oSeo {
          sSlug
        }
      }
      nWickets
      sEcon
      sOvers
      nNoBalls
      nWides
      nRunsConceded
      iBowlerId
    }
    aFOWs {
      nScoreDismissal
      nWicketNumber
      oBatter {
        sShortName
        sFullName
        eTagStatus
        oSeo {
          sSlug
        }
      }
      sOverDismissal
      iBatterId
    }
    nInningNumber
    oExtraRuns {
      nByes
      nWides
      nNoBalls
      nLegByes
      nTotal
      nPenalty
    }
    sName
    sShortName
    sResultStr
    oEquations {
      nRuns
      nWickets
      sOvers
      sRunRate
    }
`

// export const commentaryData = `
// _id
// sEventId
// sOver
// sBall
// sScore
// sHowOut
// sComSummary
// sText
// nRuns
// eEvent
// oBatter {
//   _id
//   sShortName
//   sFullName
// }
// nRuns
// eEvent
// eCommType
// ePostType
// oPostInfo {
//   sHtml
//   nTimestamp
//   sEditedBy
//   nTries
//   aPostImages {
//     sText
//     sCaption
//     sAttribute
//     sUrl
//   }
//   sTitle
// }
// iBatterId
// oBatter {
//   _id
//   sTitle
//   sShortName
//   sFullName
//   sThumbUrl
// }
// oWicketBatter {
//   _id
//   sTitle
//   sShortName
//   sFullName
//   sThumbUrl
// }
// iBowlerId
// dCreated
// dUpdated
// sComSummary
// sHowOut
// bIsNoBallDismissal
// aBatters {
//   iBatterId
//   oBatter {
//     _id
//     sTitle
//     sShortName
//     sFullName
//     sThumbUrl
//   }
//   nRuns
//   nBallFaced
//   nFours
//   nSixes
// }
// aOverScores
// aBowlers {
//   iBowlerId
//   oBowler {
//     _id
//     sTitle
//     sShortName
//     sFullName
//     sThumbUrl
//   }
//   sOvers
//   nRunsConceded
//   nWickets
//   nMaidens
// }
// iWicketBatterId
// oTeamA {
//   sTeam
//   sPlayers
// }
// oTeamB {
//   sTeam
//   sPlayers
// }
// nBatterRuns
// nBatterBalls
// sText
// sCommentary
// sTitle
// nTimestamp
// nInningNumber
// `

export const commentaryData = `
sOver
sBall
sScore
sHowOut
sComSummary
sCommentary
sText
nRuns
eEvent
aBatters {
  oBatter {
    _id
    sShortName
    sFullName
  }
  nRuns
  nBallFaced
}
oWicketBatter {
  _id
  sFullName
  sShortName
}
aBowlers {
  oBowler {
    _id
    sShortName
    sFullName
  }
  nMaidens
  nRunsConceded
  nWickets
  sOvers
}
nInningNumber
sEventId
aOverScores
nBatterRuns
nBatterBalls
oTeamA {
  sTeam
  sPlayers
}
oTeamB {
  sTeam
  sPlayers
}
dCreated
dUpdated
oOverEndScore {
  nRunsThisOver
  nWicketThisOver
}
`

export const oversData = `
oOver {
  aBatters {
    oBatter {
      _id
      eTagStatus
      sFullName
      oSeo {
        eStatus
        sSlug
      }
    }
  }
  aBowlers {
    oBowler {
      _id
      eTagStatus
      sFullName
      oSeo {
        eStatus
        sSlug
      }
    }
  }
}
nOverTotal
aBall {
  sScore
  sBall
  nRuns
  sOver
  sEventId
}
oOver {
  sScore
}
sOver
nInningNumber
`

export const liveInningData = `
aActiveBatters {
  oBatter {
    sFullName
    sShortName
    sTitle
    eTagStatus
    oSeo {
      sSlug
    }
  }
  nSixes
  nRuns
  nFours
  nBallFaced
  sStrikeRate
}
aActiveBowlers {
  oBowler {
    sFullName
    eTagStatus
    oSeo {
      sSlug
    }
  }
  sEcon
  sOvers
  nWickets
  nRunsConceded
  nMaidens
}
oCurrentPartnership {
  nBalls
  nRuns
}
sLastFiveOvers
oLastWicket {
  oBatter {
    sFullName
  }
  sHowOut
  nRuns
  nBallFaced
}
aFOWs {
  nScoreDismissal
  nWicketNumber
  oBatter {
    sShortName
    sFullName
    eTagStatus
    oSeo {
      sSlug
    }
  }
  sOverDismissal
}
`
